import script from "./SourcePersonSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./SourcePersonSelector.vue?vue&type=script&lang=ts&setup=true"

import "./SourcePersonSelector.vue?vue&type=style&index=0&id=2df0b8aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df0b8aa"]])

export default __exports__